'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import TextInput from 'Components/Forms/Elements/TextInput';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import handleChange from 'Components/Forms/Functions/handleChange';
import Dashboard from 'Components/Lists/Dashboard';
import SubscriptionRow from 'Components/Lists/Rows/Subscription';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { front_urls, URL } from 'Shared/Routes';
import { action } from 'Shared/Routes';
let app = window.app;
const header = [{
  name: 'date',
  label: 'Date de début',
  sortable: false
}, {
  name: 'end_date',
  label: 'Date de fin',
  sortable: false
}, {
  name: 'customer.lastname',
  label: 'Client',
  sortable: false
}, {
  name: 'customer.login',
  label: 'Mail',
  sortable: false
}, {
  name: 'customer.phone_number',
  label: 'Téléphone',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}];
const admin_header = [{
  name: 'date',
  label: 'Date de début',
  sortable: false
}, {
  name: 'end_date',
  label: 'Date de fin',
  sortable: false
}, {
  name: 'customer.lastname',
  label: 'Client',
  sortable: false
}, {
  name: 'customer.login',
  label: 'Mail',
  sortable: false
}, {
  name: 'customer.phone_number',
  label: 'Téléphone',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}, {
  name: 'source',
  label: 'Source',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class SubscriptionsDashboardPage extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let filters = {
      searched: state.delayed_searched,
      searched_lastname: state.delayed_searched_lastname
    };
    const is__admin = app.state.session.user?.roles?.includes?.('admin');
    if (is__admin) filters.source = 'offline';
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Abonnements"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleSearchChange,
      placeholder: "Recherche (mail)",
      value: state['searched'],
      name: "searched",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleSearchChange,
      placeholder: "Recherche (nom)",
      value: state['searched_lastname'],
      name: "searched_lastname",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "Subscription",
      url: action('getAllSubscriptions'),
      header: app.state.session?.user?.roles.includes('admin') ? admin_header : header,
      fields: fields,
      component: SubscriptionRow,
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
